import React from 'react';

const Services = () => (
  <section className="displayed-content">
    <h2>Services</h2>
    <p>We provided expertise in welding solutions and also offer mobile welding services. Please contact us to get your project started.</p>
  </section>
);

export default Services;



// WEBPACK FOOTER //
// ./src/components/Services.js